export function receivePushTimedNotificationResponse(context, { payload }) {
    const { notification } = payload;
    const notifications = context.getMethodsOf('notifications');
    notifications.pushTimedNotification(notification);
}
